export default __webpack_public_path__ + "static/media/application-icon-default.4f5664e7.svg";